async function defineCustomElements() {
  return (await import('./register.js')).default();
}

export { defineCustomElements };
